<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoRevogar" persistent :max-width="Modal.Processamento.larguraMaxima">
            <v-list-tile-title slot="activator">
                <i class="fas fa-times mr-2" aria-hidden="true"/>
                Revogar
            </v-list-tile-title>

            <modal-alterar-situacao-lote-e-item v-model="lista" :title="'Revogar'"
                                                @salvarAlteracaoSituacao="tratarEventoRevogar"
                                                @fecharModalAlteracao="tratarEventoFecharModal"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import {actionTypes, Modal} from '@/core/constants'
import ModalAlterarSituacaoLoteEItem from '@/views/pages/comprador/execucao-compra-direta/acoes/ModalAlterarSituacaoLoteEItem'

export default {
    name: 'AcoesRevogar',
    components: {ModalAlterarSituacaoLoteEItem},
    props: {
        compraDiretaId: {
            required: true
        }
    },
    data() {
        return {
            mostrarDialogoRevogar: false,
            lista: {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            },
            Modal
        }
    },
    methods: {
        async buscarResumoItensLotes() {
            this.lista = await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_ITEM_E_LOTE, this.compraDiretaId)
        },
        async tratarEventoRevogar(objModal) {
            const objParaRevogar = {
                compraDiretaId: this.compraDiretaId,
                dados: {
                    itens: objModal.itens,
                    lotes: objModal.lotes,
                    motivo: objModal.motivo,
                    situacao: 'REVOGADO'
                }
            }
            await this.$store.dispatch(actionTypes.ALTERAR_SITUACAO_DE_ITEM_E_LOTE, objParaRevogar)
            this.mostrarNotificacaoSucesso('Item revogado com sucesso.')
            this.tratarEventoFecharModal()
        },
        tratarEventoFecharModal() {
            this.mostrarDialogoRevogar = false
            this.lista = {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            }
        }
    },
    watch: {
        'mostrarDialogoRevogar': {
            async handler(novoValor) {
                if (novoValor) {
                    try {
                        await this.buscarResumoItensLotes()
                    } catch (e) {
                        this.mostrarNotificacaoErro(e.message)
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-dialog__container
        width 100%
</style>
